import { CartesianChart, type CartesianChartProps } from './CartesianChart';

export type StackedBarChartProps = Omit<CartesianChartProps, 'marks' | 'stacked'>;

/** Bars stacked per x-slot — series sum into one column. */
export const StackedBarChart = (props: StackedBarChartProps) => (
  <CartesianChart {...props} marks='bars' stacked />
);

StackedBarChart.displayName = 'StackedBarChart';
